import styled from 'styled-components';

export const SearchActionsContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding-bottom: 15px;
	padding-top: 15px;
`;

export const ActionsContainer = styled.div`
	justify-content: flex-end;
`;
